<template>
  <div class="flow-logs">
    <div v-if="logList.length > 0">
      <!-- 折叠/展开控制 -->
      <div class="logs-toggle">
        <el-button type="text" size="small" @click="toggleAll">
          <i :class="allExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          {{ allExpanded ? '全部收起' : '全部展开' }}（共 {{ logList.length }} 条）
        </el-button>
      </div>
      <el-timeline>
        <el-timeline-item
          v-for="(log, i) in logList"
          :key="i"
          :type="logColor(log.status)"
          :timestamp="formatTime(log.createTime)"
          placement="top"
        >
          <div class="log-card" :class="{ collapsed: !expandedMap[i] }">
            <div class="log-header" @click="toggleItem(i)" style="cursor: pointer;">
              <span class="log-node">{{ log.nodeTitle }}</span>
              <el-tag :type="logTagType(log.status)" size="mini">{{ logStatusText(log.status) }}</el-tag>
              <i :class="expandedMap[i] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" style="margin-left: auto; color: #909399;"></i>
            </div>
            <template v-if="expandedMap[i]">
              <div v-if="log.operatorName" class="log-operator">
                操作人：{{ log.operatorName }}
                <span v-if="log.endTime" class="log-time">（{{ formatTime(log.endTime) }}）</span>
              </div>
              <div v-if="!log.operatorName && log.owners && log.owners.length" class="log-operator">
                待处理：{{ log.owners.map(o => o.userName).join('、') }}
              </div>
              <div v-if="log.desc" class="log-comment">{{ log.desc }}</div>
            </template>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div v-else style="color:#909399;font-size:13px;">暂无审批记录</div>
  </div>
</template>

<script>
export default {
  name: 'FlowLogs',
  props: {
    value: { default: null },
    readonly: { type: Boolean, default: true },
    logs: { type: Array, default: () => [] }
  },
  data() {
    return {
      expandedMap: {}
    }
  },
  computed: {
    logList() {
      return this.logs || []
    },
    allExpanded() {
      if (this.logList.length === 0) return false
      for (let i = 0; i < this.logList.length; i++) {
        if (!this.expandedMap[i]) return false
      }
      return true
    }
  },
  watch: {
    // 当 logs 变化时，默认全部展开
    logs: {
      immediate: true,
      handler(newLogs) {
        const map = {}
        if (newLogs && newLogs.length) {
          for (let i = 0; i < newLogs.length; i++) {
            map[i] = true // 默认展开
          }
        }
        this.expandedMap = map
      }
    }
  },
  methods: {
    toggleItem(index) {
      this.$set(this.expandedMap, index, !this.expandedMap[index])
    },
    toggleAll() {
      const newVal = !this.allExpanded
      const map = {}
      for (let i = 0; i < this.logList.length; i++) {
        map[i] = newVal
      }
      this.expandedMap = map
    },
    logColor(s) {
      if (s === 'yes') return 'success'
      if (s === 'no') return 'danger'
      if (s === 'pending') return 'primary'
      if (s === 'end' || s === 'cancelled') return 'info'
      return 'info'
    },
    logTagType(s) {
      if (s === 'yes') return 'success'
      if (s === 'no') return 'danger'
      if (s === 'pending') return ''
      return 'info'
    },
    logStatusText(s) {
      if (s === 'yes') return '同意'
      if (s === 'no') return '退回'
      if (s === 'pending') return '待处理'
      if (s === 'end') return '终止'
      if (s === 'cancelled') return '已取消'
      return s
    },
    formatTime(ts) {
      if (!ts) return ''
      const d = new Date(ts)
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`
    }
  }
}
</script>

<style scoped>
.flow-logs { padding: 4px 0; }
.logs-toggle { margin-bottom: 8px; text-align: right; }
.log-card { padding: 4px 0; }
.log-card.collapsed { padding: 2px 0; }
.log-header { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }
.log-card.collapsed .log-header { margin-bottom: 0; }
.log-node { font-weight: 600; font-size: 14px; color: #303133; }
.log-operator { font-size: 13px; color: #606266; margin-bottom: 2px; }
.log-time { color: #909399; font-size: 12px; }
.log-comment { font-size: 13px; color: #409eff; background: #f0f9ff; padding: 6px 10px; border-radius: 4px; margin-top: 4px; }
</style>
